//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalDevelopmentCostWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Development Cost' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalDevelopmentCostWidget;
